// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"48":"26c7f997","140":"2b6ec5e7","621":"15fa13d2","652":"75011d2f","773":"2795381f"}[chunkId] + ".css";
};